import { HttpService } from "../http/HttpService";
import { AdminSecuritySettings } from "../http/protocol";

export interface UiSecuritySettings {
  currencyEuroValueEnabled: boolean;
  largeAmountThreshold: number;
  largeCashbackFractionRtp: number;
  largeCashbackFractionUnweighted: number;
  maxCashbackFraction: number;
  largeRakebackFractionRtp: number;
  largeRakebackFractionUnweighted: number;
  maxRakebackFraction: number;
}

export class SecuritySettingsService {
  constructor(private http: HttpService) {}

  fetchSecuritySettings(): Promise<AdminSecuritySettings> {
    return this.http.get("/admin-security/settings");
  }

  fetchUiSettings(): Promise<UiSecuritySettings> {
    return this.http.get("/admin-security/ui-settings");
  }

  saveSettings(settings: AdminSecuritySettings): Promise<AdminSecuritySettings> {
    return this.http.post("/admin-security/settings", settings);
  }
}
